import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../components/common/Icon';

/* The two blocks a company needs next to a price list, on the brand page and on the
   checkout: our paperwork, and a human.

   Documents are the media items ticked "show on the brand page" — in the Emirates a
   buyer cannot raise a purchase order without our trade licence and VAT certificate,
   and we were mailing those by hand every time. Each link is the tracked /m/<slug>
   one, so we can see which document the market actually opens.

   Special order is deliberately not a form: a form would land in a database nobody
   watches. It opens the buyer's own mail client or WhatsApp with the questions we
   would have asked anyway already typed out, so the reply arrives as a normal
   conversation with a person, on the channel they already use. The fields are left
   blank on purpose — a half-filled message is what makes someone finish it. */

const StorefrontHelp = ({ documents, contact, brandName, eventName, accentColor }) => {
  const { t } = useTranslation();
  const docs = documents || [];
  const email = (contact && contact.email) || '';
  // wa.me wants digits only: no +, no spaces, no dashes.
  const whatsapp = String((contact && contact.whatsapp) || '').replace(/\D/g, '');
  if (!docs.length && !email && !whatsapp) return null;

  const subject = t('specialOrderSubject', { brand: brandName || '' });
  const body = t('specialOrderBody', {
    brand: brandName || '',
    event: eventName || t('specialOrderNoEvent'),
  });
  const mailto = `mailto:${email}?subject=${encodeURIComponent(subject)}`
    + `&body=${encodeURIComponent(body)}`;
  const wa = `https://wa.me/${whatsapp}?text=${encodeURIComponent(body)}`;
  const outline = accentColor
    ? { borderColor: accentColor, color: accentColor } : undefined;

  return (
    <>
      {docs.length > 0 && (
        <div className="storefront__docs">
          <p className="storefront__section-label">{t('documents')}</p>
          <p className="auth__hint">{t('documentsHint')}</p>
          {docs.map((d) => (
            <a key={d.url} className="storefront__doc" href={d.url}
               target="_blank" rel="noopener noreferrer">
              <Icon name={d.kind === 'link' ? 'globe' : 'document'} className="me-2" />
              <span className="storefront__doc-title">{d.title}</span>
            </a>
          ))}
        </div>
      )}

      {(email || whatsapp) && (
        <div className="storefront__contact">
          <p className="storefront__section-label">{t('specialOrder')}</p>
          <p className="auth__hint">{t('specialOrderHint')}</p>
          <div className="storefront__contact-actions">
            {email && (
              <a className="auth__ghost" style={outline} href={mailto}>
                <Icon name="envelope" className="me-2" />
                {t('specialOrderEmail')}
              </a>
            )}
            {whatsapp && (
              <a className="auth__ghost" style={outline} href={wa}
                 target="_blank" rel="noopener noreferrer">
                <Icon name="whatsapp" pack="brands" className="me-2" />
                {t('specialOrderWhatsapp')}
              </a>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default StorefrontHelp;
